import { COLOR, mq, FONT_SIZE, Button as _Button } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivNoReviewRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  margin: 32px 0;
  border: 1px solid ${COLOR.GRAY200.code};
  border-radius: 8px;

  ${mq.tablet} {
    margin: 16px 0;
    flex-direction: column;
  }
`;

export const DivTextWrapper = styled.div`
  text-align: center;
  font-size: ${FONT_SIZE.M}px;
  flex: 1;
  padding-right: 16px;

  ${mq.tablet} {
    margin-bottom: 16px;
    padding-right: 0px;
  }

  ${mq.sp} {
    margin-bottom: 16px;
    font-size: ${FONT_SIZE.S}px;
    padding-right: 0px;
  }
`;

export const Button = styled(_Button)`
  width: 240px;
  height: 48px;

  ${mq.sp} {
    width: 200px;
  }
`;
